(function () {
  if (window.__nestPdpRelatedQuickbuyGallery20260813 === 'v5-native-close-and-unavailable-contract') return;
  window.__nestPdpRelatedQuickbuyGallery20260813 = 'v5-native-close-and-unavailable-contract';

  var preloads = {};

  function preloadButton(button) {
    var src = button && button.getAttribute('data-related-image-src');
    if (!src || preloads[src]) return preloads[src] || null;

    var image = new Image();
    image.src = src;
    image.srcset = button.getAttribute('data-related-image-srcset') || '';
    image.sizes = '(max-width: 749px) calc(96vw - 32px), 380px';
    preloads[src] = image;
    return image;
  }

  function preloadPopup(popup) {
    if (!popup || popup.getAttribute('data-related-gallery-preloaded') === 'true') return;
    popup.setAttribute('data-related-gallery-preloaded', 'true');
    Array.prototype.forEach.call(
      popup.querySelectorAll('.pdp-related-quickbuy__thumbnail'),
      preloadButton
    );
  }

  function visible(element) {
    return !!(element && element.getClientRects && element.getClientRects().length);
  }

  function preloadVisiblePopup() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.pdp-related-quickbuy'),
      function (popup) {
        if (visible(popup)) preloadPopup(popup);
      }
    );
  }

  function activate(button) {
    if (!button) return;

    var popup = button.closest('.pdp-related-quickbuy');
    var mainImage = popup && popup.querySelector('[data-related-main-image]');
    if (!mainImage || button.getAttribute('aria-pressed') === 'true') return;

    var thumb = button.getAttribute('data-related-image-thumb');
    var src = button.getAttribute('data-related-image-src');
    var srcset = button.getAttribute('data-related-image-srcset');
    var alt = button.getAttribute('data-related-image-alt');

    if (thumb) {
      mainImage.removeAttribute('srcset');
      mainImage.setAttribute('src', thumb);
    }
    if (src) mainImage.setAttribute('src', src);
    if (srcset) mainImage.setAttribute('srcset', srcset);
    if (alt) mainImage.setAttribute('alt', alt);

    Array.prototype.forEach.call(
      popup.querySelectorAll('.pdp-related-quickbuy__thumbnail'),
      function (thumbnail) {
        var active = thumbnail === button;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    );
  }

  function thumbnailFromEvent(event) {
    return event.target && event.target.closest
      ? event.target.closest('.pdp-related-quickbuy__thumbnail')
      : null;
  }

  document.addEventListener('click', function (event) {
    var thumbnail = thumbnailFromEvent(event);
    if (thumbnail) {
      activate(thumbnail);
      return;
    }

    var opener = event.target && event.target.closest
      ? event.target.closest('[data-related-quickbuy-opener]')
      : null;
    if (opener) return;
  }, true);

  document.addEventListener('mouseover', function (event) {
    var thumbnail = thumbnailFromEvent(event);
    if (!thumbnail || thumbnail.contains(event.relatedTarget)) return;
    preloadButton(thumbnail);
    activate(thumbnail);
  }, true);

  document.addEventListener('focusin', function (event) {
    var thumbnail = thumbnailFromEvent(event);
    if (thumbnail) {
      preloadButton(thumbnail);
      activate(thumbnail);
    }
  }, true);

  function relatedQuickbuyFromTarget(target) {
    return target && target.closest
      ? target.closest('.popup-container.quickbuy-modal')
      : null;
  }

  function returnFocusBeforeClose(target) {
    var popup = relatedQuickbuyFromTarget(target);
    if (!popup || !popup.classList.contains('quickbuy-modal')) return;

    var opener = popup.id
      ? document.querySelector('[aria-controls="' + popup.id + '"]')
      : null;

    if (opener && opener.focus) {
      try {
        opener.focus({ preventScroll: true });
      } catch (error) {
        opener.focus();
      }
    } else if (document.activeElement && popup.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }

  document.addEventListener('pointerdown', function (event) {
    var close = event.target && event.target.closest
      ? event.target.closest('.popup-close-icon')
      : null;
    if (close) returnFocusBeforeClose(close);
  }, true);

  document.addEventListener('click', function (event) {
    var close = event.target && event.target.closest
      ? event.target.closest('.popup-close-icon')
      : null;
    if (close) returnFocusBeforeClose(close);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') returnFocusBeforeClose(event.target);
  }, true);
})();
